module.exports = __webpack_public_path__ + "img/8.7fb244c6.jpg";